import {IReplayConfig, IPostReplayConfigResponse, ICaptureConfig, IGetReplayConfigsResponse, IPutReplayConfigResponse} from "interfaces";
import {axiosAPI} from "./API";
import { TaskState } from "enums";

// Singleton for interacting with ReplayConfigs
class _ReplayConfigService {

    // This gets set by App.tsx when okta reads the stored token
    public allReplayConfigs: IReplayConfig[] = [];
    public allReplayConfigsMap: {[uuid: string]: IReplayConfig} = {};

    public getAll = (): Promise<IGetReplayConfigsResponse> => {

        return axiosAPI.get<IGetReplayConfigsResponse>("/replayConfig")
            .then((resp) => {
                let replayConfigsResponse = resp.data;
                // save to cache
                this.allReplayConfigs = replayConfigsResponse.data;
                replayConfigsResponse.data.forEach((config) => this.allReplayConfigsMap[config.replayConfigUUID] = config);
                // filter deleted
                this.allReplayConfigs = this.allReplayConfigs.filter(r => r.status != TaskState.Deleted);
                // sort
                this.allReplayConfigs.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return replayConfigsResponse;
            })
            .catch((err) => {
                console.error("Error getting all replay configs: ", err);
                throw err;
            });
    }

    public postReplayConfig = (config: Omit<IReplayConfig, "replayConfigUUID">): Promise<IPostReplayConfigResponse> => {
        if(!config.timingOption || config.timingOption == "") {
            if(config.sinkType == "csv") {
                config.timingOption = "flood"
            }
        }
        
        return axiosAPI.post<IPostReplayConfigResponse>('/replayConfig', config)
            .then((resp) => {
                let replayConfig: IReplayConfig = {
                    replayConfigUUID: resp.data.data.replayConfigUUID,
                    ...config
                };
                // save to cache
                this.allReplayConfigs.push(replayConfig);
                this.allReplayConfigsMap[replayConfig.replayConfigUUID] = replayConfig;
                // sort
                this.allReplayConfigs.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                })
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting replay config: ", err);
                throw err;
            });
    }

    public putReplayConfig = (uuid, config: Omit<IReplayConfig, "replayConfigUUID">): Promise<IPutReplayConfigResponse> => {
        let url = `/replayConfig/${uuid}`;
        if(!config.timingOption || config.timingOption == "") {
            if(config.sinkType == "csv") {
                config.timingOption = "flood"
            }
        }
        
        return axiosAPI.put<IPutReplayConfigResponse>(url, config)
            .then((resp) => {
                let replayConfig: IReplayConfig = {
                    replayConfigUUID: resp.data.data.replayConfigUUID,
                    ...config
                };
                // update cache
                const i = this.allReplayConfigs.findIndex(c => c.replayConfigUUID === replayConfig.replayConfigUUID);
                this.allReplayConfigs.splice(i, 1, replayConfig);
                this.allReplayConfigsMap[replayConfig.replayConfigUUID] = replayConfig;
                return resp.data;
            })
            .catch((err) => {
                console.error("Error putting replay config: ", err);
                throw err;
            });
    }

    public deleteReplayConfig = (uuid: string): Promise<IReplayConfig> => {

        let url = `/replayConfig/${uuid}`;

        return axiosAPI.delete<IReplayConfig>(url)
            .then((resp) => {
                // remove from list
                this.allReplayConfigs = this.allReplayConfigs.filter(r => r.replayConfigUUID != uuid);
                // OR replace item status
                // this.allReplayConfigs[this.allReplayConfigs.findIndex(c => c.replayConfigUUID === uuid)].status = TaskState.Deleted;
                this.allReplayConfigsMap[uuid].status = TaskState.Deleted;
                return resp.data;
            })
            .catch((err) => {
                console.error("Error deleting replay config: ", err);
                throw err;
            });
    }
}

export const ReplayConfigService = new _ReplayConfigService();
